import React from 'react';
import { Users, Code, MessageSquare } from 'lucide-react';

const HireUs: React.FC = () => {
  return (
    <section id="hire" className="py-20 bg-gradient-to-b from-slate-900 to-slate-950">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-3 py-1 bg-slate-800/60 backdrop-blur-sm rounded-full text-teal-400 font-medium text-sm mb-4">
            Work With Us
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Hire Experts or Discuss Your Project
          </h2>
          <p className="text-slate-300">
            Whether you need to augment your team with skilled professionals or discuss a new project, 
            we're here to help you succeed.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-slate-800/40 backdrop-blur-sm rounded-xl p-8 border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-12 h-12 bg-blue-500/20 backdrop-blur-sm rounded-lg flex items-center justify-center mb-6">
              <Users className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Hire DevOps Engineers</h3>
            <p className="text-slate-300 mb-6">
              Add skilled DevOps engineers to your team who specialize in CI/CD, infrastructure automation, and cloud technologies.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center text-teal-400 hover:text-teal-300 font-medium transition-colors duration-300"
            >
              Hire DevOps Engineers
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </a>
          </div>
          
          <div className="bg-slate-800/40 backdrop-blur-sm rounded-xl p-8 border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-12 h-12 bg-teal-500/20 backdrop-blur-sm rounded-lg flex items-center justify-center mb-6">
              <Code className="w-6 h-6 text-teal-400" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Hire Developers</h3>
            <p className="text-slate-300 mb-6">
              Get access to skilled developers with expertise in various technologies to help build and maintain your applications.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center text-teal-400 hover:text-teal-300 font-medium transition-colors duration-300"
            >
              Hire Developers
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </a>
          </div>
          
          <div className="bg-slate-800/40 backdrop-blur-sm rounded-xl p-8 border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-12 h-12 bg-purple-500/20 backdrop-blur-sm rounded-lg flex items-center justify-center mb-6">
              <MessageSquare className="w-6 h-6 text-purple-400" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Discuss Your Project</h3>
            <p className="text-slate-300 mb-6">
              Have a project in mind? Let's discuss how we can help you bring your vision to life with our technical expertise.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center text-teal-400 hover:text-teal-300 font-medium transition-colors duration-300"
            >
              Start a Conversation
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HireUs;